import { render, staticRenderFns } from "./ContactNotFound.vue?vue&type=template&id=3962ccf2"
import script from "./ContactNotFound.vue?vue&type=script&lang=js"
export * from "./ContactNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports